import { getDataGridDynamicHeight } from '@modules/common/utils';
import { useUserManagementStore } from '@modules/users/store/hooks';
import {
  getDomainUsersColumns,
  getDomainUsersGridInitialState,
  getDomainUsersRows,
} from '@modules/users/utils';
import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useGetUser } from 'v2/core/services/user';

const TABLE_HEIGHT = 200;
const ROW_HEIGHT = 38;
const HEADER_HEIGHT = 38;

export const DomainUsersTable = () => {
  const {
    tenant: { domains },
  } = useGetUser();

  const isLoading = useUserManagementStore(
    ({ visual }) => visual.isFetchingUsers,
  );
  const users = useUserManagementStore(({ users }) => users);

  const columns = getDomainUsersColumns();
  const rows = getDomainUsersRows(domains ?? [], users);
  const initialState = getDomainUsersGridInitialState();

  return (
    <Box
      sx={{
        height: getDataGridDynamicHeight(
          TABLE_HEIGHT,
          rows.length,
          ROW_HEIGHT,
          HEADER_HEIGHT,
        ),
        width: '100%',
      }}
    >
      <DataGridPro
        sx={{
          border: 'none',
        }}
        initialState={initialState}
        loading={isLoading}
        rows={rows}
        columns={columns}
        rowHeight={ROW_HEIGHT}
        columnHeaderHeight={HEADER_HEIGHT}
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick
        getRowId={({ domain }) => domain}
      />
    </Box>
  );
};
